import React, { Fragment } from "react"
// import { navigate } from "gatsby"
import Img from "gatsby-image"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTag } from "@fortawesome/free-solid-svg-icons"

import Heading from "../heading"
import Section from "../section"

const Catalog = ({ products }) => {
  return (
    <Section id="catalog" className="mt-5">
      <Heading>Our Products</Heading>
      <div className="row justify-content-center pt-4">
        {products?.map((product, index) => {
          return (
            <div className="col-sm-12 col-md-6 col-lg-4 text-left" key={index}>
              <div
                className="card mb-4 product-card"
                // onClick={() => navigate(product?.gatsbyPath)}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") navigate(product?.gatsbyPath)
                // }}
                // tabIndex="0"
                // role="link"
              >
                <a href={`${product?.gatsbyPath}`} rel="noreferrer noopener">
                  <Img
                    fluid={product?.data?.featured_color?.fluid}
                    alt={product?.data?.header?.text}
                    className="card-img-top rounded"
                    // width="600px"
                    // height="200px"
                    // style={{ objectFit: "fill" }}
                  />

                  <Fragment key={index}>
                    <div className="card-body p-1 pt-3">
                      <h5 className="card-title text-primary">
                        {product?.data?.header?.text}
                      </h5>

                      <p className="card-text small text-muted">
                        <span className="icon">
                          <FontAwesomeIcon icon={faTag} />{" "}
                        </span>
                        {product?.data?.specs_industry?.text}
                      </p>
                    </div>
                  </Fragment>
                </a>
              </div>
            </div>
          )
        })}
        {/* {products?.map((product, index) => {
          return (
            <div className="col-sm-12 col-md-6 col-lg-4" key={index}>
              <div
                className="card mb-4 product-card"
                onClick={() => navigate(product?.gatsbyPath)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") navigate(product?.gatsbyPath)
                }}
                tabIndex="0"
                role="link"
              >
                <img
                  src={product?.data?.featured_color?.url}
                  alt={product?.data?.header?.text}
                  className="card-img-top"
                  width="600px"
                  height="200px"
                  style={{ objectFit: "fill" }}
                />

                <div className="card-body text-left">
                  <div className="row">
                    <div className="col-8-xs ml-2">
                      <button className="btn btn-primary" width="100%">
                        {product?.data?.header?.text}
                      </button>
                    </div>
                    <div className="col-auto">
                      <p className="small text-muted mb-1">
                        <FontAwesomeIcon icon={faInfoCircle} />{" "}
                        {product?.data?.specs_backing?.text} |{" "}
                        {product?.data?.specs_finish?.text}
                      </p>
                      <p className="small text-muted mb-0">
                        <FontAwesomeIcon icon={faTag} />{" "}
                        {product?.data?.specs_industry?.text}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })} */}
      </div>
    </Section>
  )
}

export default Catalog
